import { createElementBlock as e, defineComponent as t, openBlock as n, renderSlot as r } from "vue";
//#region src/schema/components/WithBreadcrumb.vue?vue&type=script&setup=true&lang.ts
var i = ["id"], a = /*@__PURE__*/ t({
	__name: "WithBreadcrumb",
	props: { breadcrumb: {} },
	setup(t) {
		return (a, o) => t.breadcrumb && t.breadcrumb.length > 0 ? (n(), e("div", {
			key: 0,
			id: t.breadcrumb.join("."),
			class: "static scroll-mt-24",
			tabindex: "-1"
		}, [r(a.$slots, "default")], 8, i)) : r(a.$slots, "default", {}, void 0, void 0, 1);
	}
});
//#endregion
export { a as default };

//# sourceMappingURL=WithBreadcrumb.vue_vue_type_script_setup_true_lang.js.map